export function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function urlize(url: string) {
    if (!url.startsWith('http')) {
        url = process.env.VUE_APP_CMS_URL + url;
    }
    return url;
}

export function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}
